// @flow
import React from 'react';
import { TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';

import { TABLEFLOW_WORKLOAD_DETAILS_CONFIG_MAP } from '../config';

export const SPTableFlowWorkloadNameContainer = ({ disabled = false }) => {
  const { backendFieldName, displayName } = TABLEFLOW_WORKLOAD_DETAILS_CONFIG_MAP.get(
    TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME
  );
  return (
    <TextField disabled={disabled} fieldDisplayName={displayName} fieldName={backendFieldName} />
  );
};
